import { Trader, TraderFromJSON } from '@/api'
import * as runtime from '../runtime'

export class TraderApi extends runtime.BaseAPI {
  /**
   * 業者を取得する
   * 業者取得
   */
  async getTrader(): Promise<Trader[]> {
    const response = await this.requestGet('/traders')

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(TraderFromJSON)
    ).value()
  }
}
